import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { AddAnalysisPage, useOcrQueue } from '@practium/features/analyses';
import type { AnalysesTab } from '@practium/features/analyses';

export const AddAnalysisPageClient = () => {
	const navigate = useNavigate();
	const location = useLocation();
	const [searchParams] = useSearchParams();
	const type = (searchParams.get('type') as AnalysesTab) || 'soil';
	const { getItem, remove, advanceSample } = useOcrQueue();
	const ocrItemId = (location.state as { ocrItemId?: string } | null)?.ocrItemId;
	const ocrItem = ocrItemId ? getItem(ocrItemId) : undefined;

	return (
		<AddAnalysisPage
			type={type}
			ocrSample={ocrItem?.samples?.[ocrItem.sampleIndex]}
			ocrFileName={ocrItem?.fileName}
			ocrSampleIndex={ocrItem?.sampleIndex}
			ocrSampleTotal={ocrItem?.samples?.length}
			onOcrSaved={() => {
				if (!ocrItemId || !ocrItem) return false;
				if (advanceSample(ocrItemId)) return true;
				remove(ocrItemId);
				return false;
			}}
			onOcrCancelled={() => {
				if (ocrItemId) remove(ocrItemId);
			}}
			onBack={() => navigate('/analises')}
		/>
	);
};
